<div class="rules-page">
  <div class="rules-header">
    <div>
      <h1>Country term rules</h1>
      <p>Per country: what a field is called on chain, whether it's required, and whether it may be published.</p>
    </div>
    @if (canEdit) {
      <button mat-flat-button class="btn-submit" (click)="openUpsertDialog()">
        <mat-icon>add</mat-icon>
        New rule
      </button>
    }
  </div>

  <div class="toolbar">
    <input
      [(ngModel)]="countryCodeFilter"
      name="countryCodeFilter"
      placeholder="Filter by country code (e.g. CN)"
      (keyup.enter)="load()"
    />
    <button class="secondary-btn" (click)="load()">Filter</button>
  </div>

  <app-error-banner [message]="errorMessage()" />

  @if (isLoading()) {
    <p class="hint">Loading...</p>
  } @else if (rules().length === 0) {
    <app-empty-state message="No term rules configured yet." />
  } @else {
    <table>
      <thead>
        <tr>
          <th>Country</th>
          <th>Field</th>
          <th>Event type</th>
          <th>Local name</th>
          <th>Required</th>
          <th>On chain</th>
          @if (canEdit) {
            <th></th>
          }
        </tr>
      </thead>
      <tbody>
        @for (rule of pagedRules; track ruleKey(rule)) {
          <tr>
            <td>{{ rule.countryCode }}</td>
            <td>{{ rule.term }}</td>
            <td>{{ rule.eventType }}</td>
            <td>{{ rule.localName || '—' }}</td>
            <td>{{ rule.required ? 'Yes' : 'No' }}</td>
            <td>{{ rule.onChain ? 'Yes' : 'No' }}</td>
            @if (canEdit) {
              <td>
                <button
                  class="remove-btn"
                  (click)="deleteRule(rule)"
                  [disabled]="deletingKey() === ruleKey(rule)"
                  aria-label="Remove term rule"
                  title="Remove term rule"
                >
                  <svg class="bin-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <g class="bin-icon__lid">
                      <line x1="4" y1="7" x2="20" y2="7" />
                      <path d="M10 7V4.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1V7" />
                    </g>
                    <path d="M6 7l1 13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-13" />
                    <line x1="10" y1="11" x2="10" y2="17" />
                    <line x1="14" y1="11" x2="14" y2="17" />
                  </svg>
                </button>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>

    <div class="pagination">
      <div class="page-size-control">
        <span>Results per page</span>
        <app-page-size-select [sizes]="pageSizeOptions" [ngModel]="pageSize()" (ngModelChange)="onPageSizeChange($event)" name="pageSize" />
      </div>

      <div class="pagination-pill">
        <button class="page-nav" (click)="goToPage(page() - 1)" [disabled]="page() === 0">
          <span class="material-icons">chevron_left</span>
          Previous
        </button>
        @for (p of pageWindow; track $index) {
          @if (p === -1) {
            <span class="page-ellipsis">…</span>
          } @else {
            <button class="page-dot" [class.page-dot--active]="p === page()" (click)="goToPage(p)">
              {{ p + 1 }}
            </button>
          }
        }
        <button class="page-nav" (click)="goToPage(page() + 1)" [disabled]="page() === totalPages - 1">
          Next
          <span class="material-icons">chevron_right</span>
        </button>
        <span class="pagination-divider"></span>
        <span class="pagination-summary">Showing {{ rangeStart }}–{{ rangeEnd }} of {{ totalCount }} rules</span>
      </div>
    </div>
  }
</div>
